import {
  ApolloClient,
  InMemoryCache,
  split,
  HttpLink,
  ApolloLink,
  FetchResult,
  Operation,
  NextLink,
  Observable,
} from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { OperationDefinitionNode, FieldNode } from "graphql";
import * as Sentry from "@sentry/react";
import { getToken } from "../utils/helpers/auth";

import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
//import { refreshToken } from "./refreshToken";
import { autoLogout } from "./autoLogout";
//import { Observable } from "redux";
//import Operation from "antd/es/transfer/operation";
//import { getNotificationMessage } from "../store/actions/localStorageActions";
//import { useAuth } from "react-oidc-context";

//import { useAuthCheck } from "../components/CustomHooks/useAuthCheck";
const GRAPHQL_MO_URL = process.env.GRAPHQL_MO_URL; // Mid Office Api Service.
const GRAPHQL_URL = process.env.GRAPHQL_URL; // User Api Service.
const GRAPHQL_BE_URL = process.env.GRAPHQL_BE_URL; // Booking Engine Api Service.

const GRAPHQL_WS_URL = "ws://localhost:4000/graphql";

const httpLink = new HttpLink({
  uri: GRAPHQL_URL,
});

const httpLink_MO = new HttpLink({
  uri: GRAPHQL_MO_URL,
});

const httpLink_BE = new HttpLink({
  uri: GRAPHQL_BE_URL,
});

const token = getToken() ? `Bearer ${getToken()}` : "";

const authLink = setContext((_, { headers }) => {
  const customHeaders = _.variables?.headers || {}; // Access headers from variables
  return {
    headers: {
      ...headers,
      Authorization: token,
      ...customHeaders, // Add custom headers from variables
    },
  };
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: GRAPHQL_WS_URL,
    connectionParams: {
      headers: {
        Authorization: token,
      },
    },
  })
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  authLink.concat(httpLink) // Use the authLink with the httpLink
);

const splitLink_MO = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  authLink.concat(httpLink_MO) // Use the authLink with the httpLink
);

const splitLink_BE = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  authLink.concat(httpLink_BE) // Use the authLink with the httpLink
);

// export const clientBE = new ApolloClient({
//   link: ApolloLink.from([splitLink]), // Use ApolloLink.from to properly combine links
//   cache: new InMemoryCache(),
//   connectToDevTools: true,
// });

// const errorLink = onError(
//   ({
//     graphQLErrors,
//     operation
//   }) => {
//     const operationName = operation.operationName;
//     if (operationName === "MailTemplate") {
//       if (graphQLErrors) {
//         graphQLErrors.forEach(({ extensions }) => {
//           if (extensions?.code === "AUTH_NOT_AUTHORIZED") {
//             return;
//           }
//         });
//       }

//       return; // stop further handling
//     }

//     if (graphQLErrors) {
//       graphQLErrors.forEach(({ extensions }) => {
//         if (extensions?.code === "AUTH_NOT_AUTHORIZED") {
//           //refreshToken();
//           autoLogout();
//           return;
//         }
//       });
//       //const { logout } = useAuthCheck();
//       // graphQLErrors.forEach(({ message }) => {
//       //   if (message.includes("not authorized")) {
//       //     // logout();

//       //     // customNotify({
//       //     //   message: "Token expired. redirecting user to login page",
//       //     //   description: "",
//       //     //   type: "warning",
//       //     //   onClose: logout,
//       //     // });

//       //     // const auth = useAuth();
//       //     // setTimeout(() => {
//       //     //   localStorage.removeItem("token");
//       //     //   localStorage.removeItem("wrapper_token");
//       //     //   auth.removeUser();
//       //     //   auth.signoutRedirect();
//       //     // }, 200);
//       //     // localStorage.clear();
//       //     // sessionStorage.clear();
//       //     // window.location.href = "/";
//       //   }
//       // });
//     }

//     // if (networkError) {
//     //   if ("statusCode" in networkError && networkError.statusCode === 500) {
//     //     customNotify({
//     //       message:
//     //         "System taking too long to load the results. Check your network and try again",
//     //       description: "",
//     //       type: "error",
//     //     });
//     //   } else {
//     //     // Handle other network errors if needed
//     //   }
//     // }
//   }
// );

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const authError = graphQLErrors?.some(
    err => err.extensions?.code === "AUTH_NOT_AUTHORIZED"
  );


  if (authError) {
    autoLogout();
    return;
  }

  if (networkError) {
    Sentry.captureException(networkError);
  }
});

const statusCheckLink = new ApolloLink(
  (operation: Operation, forward: NextLink): Observable<FetchResult> => {
    if (!forward) {
      return new Observable<FetchResult>((observer) => {
        observer.complete();
      });
    }
    return forward(operation).map((response: FetchResult) => {
      const def = getMainDefinition(operation.query) as OperationDefinitionNode;
      const firstSelection = def.selectionSet.selections[0];
      const apiName = (firstSelection as FieldNode).name.value;
      let status =
        response?.data?.[apiName!]?.responseData?.status ??
        response?.data?.[apiName]?.successTypeCode ??
        "";
      if (typeof status === "string") {
        status = status.toLowerCase();
      } else if (status === false || status === "false") {
        status = "fail";
      }

      if (status === "fail" || status === "failed") {
        Sentry.captureEvent({
          message: `${apiName} - API`,
          level: "error",
          extra: {
            //operation: apiName,
            //variables: operation.variables,
            apiResponse: JSON.stringify(response, null, 2),
          },
        });
      }

      return response;
    });
  }
);

export const client = new ApolloClient({
  link: ApolloLink.from([statusCheckLink, errorLink, splitLink]), // Use ApolloLink.from to properly combine links
  cache: new InMemoryCache({ addTypename: false }),
  connectToDevTools: true,
});

export const client_MO = new ApolloClient({
  link: ApolloLink.from([statusCheckLink, errorLink, splitLink_MO]), // Use ApolloLink.from to properly combine links
  cache: new InMemoryCache({ addTypename: false }),
  connectToDevTools: true,
});

export const client_BE = new ApolloClient({
  link: ApolloLink.from([statusCheckLink, errorLink, splitLink_BE]), // Use ApolloLink.from to properly combine links
  cache: new InMemoryCache({ addTypename: false }),
  connectToDevTools: true,
});
